import EventEdit from '@/screens/EventEdit';

export default function PrivateEventCreateIndexRoute() {
  return <EventEdit />;
}
